import React from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  className?: string;
}
export function SearchInput({
  value,
  onChange,
  placeholder,
  className = ''
}: SearchInputProps) {
  return <div className={`relative ${className}`} data-id="element-362" data-mp="1d6il01pqvdlt">
      <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-400" data-id="element-363" data-mp="1d7biec2tcqra" />
      <input type="text" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} aria-label={placeholder} className="h-9 w-full rounded-lg border border-ink-200 bg-white pl-9 pr-8 text-[13px] text-ink-800 placeholder:text-ink-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500" data-id="element-364" data-mp="1h9om6uy02elf" />
      {value && <button type="button" onClick={() => onChange('')} aria-label="Clear search" className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 text-ink-400 hover:bg-ink-100 hover:text-ink-600" data-id="element-365" data-mp="3szhjrren83t3">
          <XIcon className="h-3.5 w-3.5" data-id="element-366" data-mp="y1kmgy7c3u6r" />
        </button>}
    </div>;
}